<template>
    <CategoryAsideBlock
        v-if="categoryList.parent || categoryList.categories"
        :title="i18n('Category')"
        class="category-nav"
    >
        <nav class="category-nav__list">
            <div class="nav-aside">
                <ul v-if="categoryList.parent && categoryList.parent.url">
                    <li>
                        <a
                            :href="categoryList.parent.url"
                            class="category-nav__parent"
                        >
                            <span class="icon icon-arrow-indicators"></span>
                            <span
                                >Cofnij do {{ categoryList.parent.name }}</span
                            >
                        </a>
                    </li>
                </ul>
                <CategoryTreeList
                    v-if="categoryList.children"
                    :category="categoryList.children"
                />
            </div>
        </nav>
    </CategoryAsideBlock>
</template>
<script>
import { mapGetters } from 'vuex'
import { CategoryAsideBlock } from '../CategoryAside'
import CategoryTreeList from './CategoryTreeList.vue'
export default {
    components: {
        CategoryAsideBlock,
        CategoryTreeList
    },
    props: {
        categoryList: {
            type: Object,
            required: true
        }
    },
    computed: {
        ...mapGetters(['i18n'])
    }
}
</script>
<style lang="scss">
.category-nav {
    $b: &;
    .category-aside__title {
        margin-bottom: 0;
    }

    &__parent {
        align-items: center;
        padding-left: 1.5rem;

        .icon {
            transform: rotate(90deg);
            width: 10px;
            height: 10px;
        }
    }

    #{$b}__parent {
        display: flex;
        gap: 10px;

        @media #{$media-xs} {
            padding-left: 15px;
        }

        &:hover,
        &:focus {
            .icon {
                filter: brightness(0) invert(1);
            }
        }
    }
}
</style>
